import { Grid2 } from "@mui/material";
import Alert from "./Alert";
import HeaderBar from "../Shared/HeaderBar/HeaderBar";
import NavigationBar from "../Shared/NavigationBar/NavigationBar.js"

const alerts = [
    {
        station: "KOMO",
        title: "Test Alert 1",
        message:
            "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.",
        severity: "low",
    },
    {
        station: "KOMO",
        title: "Test Alert 2",
        message:
            "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.",

        severity: "high",
    },
    {
        station: "KOMO",
        title: "Test Alert 3",
        message:
            "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.",

        severity: "medium",
    },
    {
        station: "KOMO",
        title: "Test Alert 4",
        message:
            "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.",

        severity: "high",
    },
    {
        station: "KOMO",
        title: "Test Alert 5",
        message:
            "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.",

        severity: "low",
    },
];

export default function AlertsPage() {
    return (
        <>
            <HeaderBar></HeaderBar>
            <Grid2 container={true} direction={'row'} rowSpacing={1} alignContent={'center'} justifyContent={'center'} id={"AlertsPageGrid"}>
                {alerts.map((alert, id) => (
                    <Alert
                        id={id}
                        station={alert.station}
                        title={alert.title}
                        message={alert.message}
                        severity={alert.severity}
                        sx={{width:5}}
                    />
                ))}
            </Grid2>
            <NavigationBar></NavigationBar>
        </>
    );
}
